import { render, staticRenderFns } from "./ActivateResponsibility.vue?vue&type=template&id=3c2d27f0"
import script from "./ActivateResponsibility.vue?vue&type=script&lang=js"
export * from "./ActivateResponsibility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports